<template>
  <div class="personnel-on-duty-schedule-modify">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">出入口设备：</span>
        </div>
        <el-select v-model="formData.deviceCode" size="small" style="width: 280px">
          <el-option v-for="item in parkingAccessManageList" :key="item.code"
                     :label="item._label" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">值班人员：</span>
        </div>
        <el-select v-model="formData.personCode" filterable remote reserve-keyword size="small" style="width: 280px" :remote-method="remoteMethod" placeholder="请输入关键词查询">
          <el-option v-for="item in responsiblePersonList" :key="item._value"
                     :label="item._label" :value="item._value">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">班次：</span>
        </div>
        <el-select v-model="formData.routeCode" size="small" style="width: 280px">
          <el-option v-for="item in parkingEmergencyRouteList" :key="item.code"
                     :label="item.routeName" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import md5 from 'js-md5'
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../../components/Text/TextTitle'
import ButtonConfirm from '../../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../../components/Button/ButtonCancel'
import {errorHandler} from '../../../../utils/errorHandler'
import {api} from '../../../api/ParkingService'
import {nError, nSuccess} from '../../../../utils/notice'
import {pattern} from '../../../../utils/regular'

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb},
  name: 'personnel-on-duty-schedule-modify',
  data () {
    return {
      breadcrumb: [
        {value: "智慧停车", name: "parking-device-management"},
        {value: "排班管理"}
      ],
      mainTitle: '修改排班',
      subheading: '',

      parkingAccessManageList: [],
      parkingEmergencyRouteList: [],
      responsiblePersonList: [],
      formData: {
        deviceName: '',
        deviceCode: '',
        personCode: '',
        personName: '',
        personPhone: '',
        routeCode: '',
        routeName: '',
      }
    }
  },
  created () {
    this.getParkingAccountByCode()
    this.getParkingAccessManageList()
    this.getParkingEmergencyRouteList()
  },
  methods: {
    toMangePage () {
      this.$router.push({
        name: 'personnel-on-duty-schedule-manage'
      })
    },

    // 获取信息
    getParkingAccountByCode () {
      this.$axios.get(`${api.getParkingEmergencyRoutePlanByCode}/${this.$route.params.id}`, {})
        .then(res => {
          let data = res.data.data
          this.formData = data
          this.remoteMethod(data.personName)
        })
        .catch(errorHandler('获取信息失败'))
    },

    remoteMethod (query) {
      this.getResponsiblePersonList(query)
    },

    // 查询责任人
    getResponsiblePersonList (searchKey) {
      this.$axios.post(api.getResponsiblePersonList, {
        searchKey: searchKey || ''
      })
        .then(res => {
          let list = res.data.data
          list.forEach(it => {
            it._value = it.code
            it._label = `${it.name} / ${it.phone} / ${it.enterpriseName}`
          })
          this.responsiblePersonList = list
        })
        .catch(errorHandler('查询失败'))
    },

    // 查询出入口列表
    getParkingAccessManageList () {
      this.$axios.post(api.getParkingAccessManageList, {})
        .then(res => {
          let list = res.data.data
          list.map(v => {
            v._label = `${v.name}/${v.location}`
          })
          this.parkingAccessManageList = list
        })
        .catch(errorHandler('查询出入口设备失败'))
    },

    // 查询班次列表
    getParkingEmergencyRouteList () {
      this.$axios.post(api.getParkingEmergencyRouteList, {})
        .then(res => {
          let list = res.data.data
          this.parkingEmergencyRouteList = list
        })
        .catch(errorHandler('查询班次列表失败'))
    },

    confirm () {
      if (!this.formData.deviceCode) {
        nError('请选择出入口设备')
        return false
      }
      if (!this.formData.personCode) {
        nError('请选择值班人员')
        return false
      }
      if (!this.formData.routeCode) {
        nError('请选择班次')
        return false
      }
      this.parkingAccessManageList.map(v => {
        if (v.code === this.formData.deviceCode) {
          this.formData.deviceName = v.name
        }
      })
      this.parkingEmergencyRouteList.map(v => {
        if (v.code === this.formData.routeCode) {
          this.formData.routeName = v.routeName
        }
      })
      this.responsiblePersonList.map(v => {
        if (v.code === this.formData.personCode) {
          this.formData.personName = v.name
          this.formData.personPhone = v.phone
        }
      })
      this.$axios.post(api.updateParkingEmergencyRoutePlan, this.formData)
        .then(res => {
          nSuccess('修改成功')
          this.toMangePage()
        })
        .catch(errorHandler('修改失败'))
    },
    cancel () {
      this.toMangePage()
    }
  },
}
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #FF0000;
  vertical-align: -webkit-baseline-middle;
}
.form-line {
  margin: 20px 0;
}
.line-text{
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.dialogLine {
  width: 60%;
  margin: 20px auto;
  display: flex;
  justify-content: center;
}
.dialogLine div {
  min-width: 80px;
  text-align: right;
  margin-right: 10px;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/PersonnelOnDuty/PersonnelOnDutySchedule/PersonnelOnDutyScheduleModify.vue